import React from 'react';
import { Bell } from 'lucide-react';
import { NotificationItem, resolvePresentation } from '../../composables/notificationAPI';

// การ์ดพรีวิวหน้าตาที่สมาชิกจะเห็นในแจ้งเตือนจริง ใช้ในหน้า Admin (AdminNotificationCompose) เพื่อโชว์
// ผลลัพธ์หลังสร้าง/ทดสอบ/เผยแพร่ แทนการโชว์ raw JSON ตรง ๆ — ดีไซน์อ้างอิง NotificationRow/
// NewNotificationToast ฝั่งผู้ใช้จริง แต่เป็นภาพนิ่ง ไม่มี interaction (กด seen/read/dismiss ไม่ได้)
const NotificationPreviewCard: React.FC<{ item: Partial<NotificationItem> }> = ({ item }) => {
  const presentation = resolvePresentation(item as NotificationItem);
  const ctaUrl = item.primaryAction?.url || item.deepLink;

  return (
    <div
      className="rounded-2xl p-4 border"
      style={{ backgroundColor: 'var(--bg-item)', borderColor: 'var(--border-item-dark, transparent)' }}
    >
      <div className="flex items-start gap-3">
        <div
          className="w-12 h-12 rounded-lg overflow-hidden shrink-0 flex items-center justify-center text-xl"
          style={{ backgroundColor: 'var(--bg-navbar, #e5e7eb)' }}
        >
          {item.image ? (
            <img src={item.image} alt="" className="w-full h-full object-cover" />
          ) : presentation.icon ? (
            presentation.icon
          ) : (
            <span style={{ color: 'var(--secondary-text-color)' }}><Bell size={18} /></span>
          )}
        </div>

        <div className="min-w-0 flex-1">
          <span
            className="inline-block text-[10px] font-bold px-2 py-0.5 rounded-full mb-1"
            style={{ backgroundColor: 'var(--bg-navbar, #e5e7eb)', color: 'var(--secondary-text-color)' }}
          >
            {presentation.icon ? `${presentation.icon} ${presentation.label}` : presentation.label}
          </span>
          <div className="text-sm font-bold truncate">{item.title || '(ยังไม่ได้ใส่หัวข้อ)'}</div>
          <p className="text-xs opacity-75 mt-0.5 whitespace-pre-wrap">{item.body || '(ยังไม่ได้ใส่เนื้อหา)'}</p>
        </div>
      </div>

      <div className="flex items-center gap-2 mt-2.5 flex-wrap">
        {ctaUrl && (
          <span
            className="inline-flex items-center text-[11px] font-semibold px-2.5 py-1.5 rounded-full border"
            style={{ borderColor: 'var(--bg-navbar, #333)', color: 'var(--text-color)' }}
          >
            {presentation.cta}
          </span>
        )}
        {item.acknowledgement?.required && (
          <span
            className="inline-flex items-center text-[11px] font-semibold px-2.5 py-1.5 rounded-full"
            style={{ backgroundColor: 'var(--green-text-color)', color: '#fff' }}
          >
            {item.acknowledgement.label || 'รับทราบ'}
          </span>
        )}
      </div>
    </div>
  );
};

export default NotificationPreviewCard;
